<script setup lang="ts">
import { inject, defineProps, computed } from 'vue'

const props = defineProps<{ class?: string }>()
const toggle = inject('toggle') as ((value: string) => void)
const openValue = inject('openValue')
const value = inject('value') as string

const isOpen = computed(() => openValue?.value === value)

function handleClick() {
  toggle?.(value)
}
</script>

<template>
  <button
  @click="handleClick"
  :class="[
    'flex items-center justify-between w-full py-4 font-medium text-lg sm:text-2xl md:text-3xl transition-all hover:underline cursor-pointer',
    props.class
  ]"
>
  <slot />
  <svg
    class="h-4 w-4 shrink-0 transition-transform duration-200"
    :class="{ 'rotate-180': isOpen }"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
  </svg>
</button>

</template>
